export default __webpack_public_path__ + "static/media/play-button-white-circle.36180823.svg";